
export default function Contact() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-green-800">Contact Us</h2>
      <p className="mt-2">📍 No. 105, Boundary road, Batticaloa</p>
      <p>📞 +94 76 430 0539</p>
      <p>📧 herbartzclinic@gmail.com</p>
    </div>
  );
}
